export const FLOOR_PLAN_ROUTE_NAMES = {
  LIST: 'floorPlanList',
  TABLE_LIST: 'floorPlanTableList',
  TABLE_EDIT: 'floorPlanTableEdit',
}
